import { render, staticRenderFns } from "./VoluntaryLineSuspensionComponent.vue?vue&type=template&id=2517c4f3&scoped=true&"
import script from "./VoluntaryLineSuspensionComponent.vue?vue&type=script&lang=js&"
export * from "./VoluntaryLineSuspensionComponent.vue?vue&type=script&lang=js&"
import style0 from "./VoluntaryLineSuspensionComponent.vue?vue&type=style&index=0&id=2517c4f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2517c4f3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCard,VCardText,VCardTitle,VCol,VDivider,VList,VListItem,VListItemContent,VListItemTitle,VRow})
